import { ITERABLE_NAME as NAME, ITERABLE_DISPLAY_NAME as DISPLAY_NAME } from '../Destinations';

const DIR_NAME = 'Iterable';

const DISPLAY_NAME_TO_DIR_NAME_MAP = { [DISPLAY_NAME]: DIR_NAME };
const CNameMapping = {
  [NAME]: NAME,
  Iterable: NAME,
  iterable: NAME,
};

export { NAME, CNameMapping, DISPLAY_NAME_TO_DIR_NAME_MAP, DISPLAY_NAME, DIR_NAME };
